import { getAuthHeaders } from "./auth";

async function request(path, body, method = "GET") {
    const response = await fetch(path, {
        method,
        headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
        body: body ? JSON.stringify(body) : undefined
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.detail || data.message || `Ошибка запроса цен: ${response.status}`);
    return data;
}

export const catalogPriceSnapshots = partNumbers => request("/api/catalog-prices/snapshots", { part_numbers: partNumbers }, "POST");
export const requestCatalogPrices = ({ partNumber, manufacturer, quantity }) => request("/api/catalog-prices/requests", { part_number: partNumber, manufacturer, quantity }, "POST");
export const catalogPriceRequest = id => request(`/api/catalog-prices/requests/${id}`);
export const catalogPriceHistoryOffers = (partNumber, date) => request(`/api/catalog-prices/history/offers?${new URLSearchParams({ partNumber, date })}`);

export const catalogPriceHistory = partNumber => request(`/api/catalog-prices/history?${new URLSearchParams({ partNumber, days: "3650" })}`);
